import DropBox from "assets/svgs/dropbox.svg";
import GoogleDriveIcon from "assets/svgs/googledrive.svg";
import OneDriveIcon from "assets/svgs/onedrive.svg";
import GoogleDocIcon from "assets/svgs/simple-icons_googledocs.svg";
import GoogleSheetIcon from "assets/svgs/simple-icons_googlesheets.svg";
import VectorIcon from "assets/svgs/vectoricon.svg";
import { UploadOptionId } from "./types";

export const uploadOptions = [
  { label: "Upload File", icon: VectorIcon, id: UploadOptionId.UploadFile },
  { label: "Dropbox", icon: DropBox, id: UploadOptionId.Dropbox },
  {
    label: "OneDrive/SharePoint",
    icon: OneDriveIcon,
    id: UploadOptionId.OneDrive,
  },
  {
    label: "Google Drive",
    icon: GoogleDriveIcon,
    id: UploadOptionId.GoogleDrive,
  },
  {
    label: "New Google Doc",
    icon: GoogleDriveIcon,
    id: UploadOptionId.NewGoogleDocMenu,
    subData: [
      {
        label: "New Google Doc",
        icon: GoogleDocIcon,
        id: UploadOptionId.NewGoogleDoc,
      },
      {
        label: "New Google Sheet",
        icon: GoogleSheetIcon,
        id: UploadOptionId.NewGoogleSheet,
      },
    ],
  },
];
